/**
 * The statuses after which Gibson sends nothing further. Declared once here so the
 * backend (callback + polling staleness re-fetch) and the web app (polling hook)
 * cannot drift on what "finished" means.
 *
 * Mirrors `ProductEvaluationStatus.COMPLETE` / `ERROR` in `@common-sense-privacy/db`,
 * spelled out as literals so importing this contract never pulls the entity layer
 * into the browser bundle.
 */
export const COMPLETE_EVALUATION_STATUS = 'complete';
export const ERROR_EVALUATION_STATUS = 'error';
export const TERMINAL_EVALUATION_STATUSES = [
    COMPLETE_EVALUATION_STATUS,
    ERROR_EVALUATION_STATUS,
];
const terminalStatuses = TERMINAL_EVALUATION_STATUSES;
/**
 * An unrecognised status is non-terminal, so polling keeps running rather than
 * stranding the user on a status Gibson later moves off.
 */
export const isTerminalEvaluationStatus = (status) => terminalStatuses.includes(status ?? '');
/**
 * Whether the user has dealt with a mapped answer: either a real answer is saved
 * against the question, or they skipped it. A skip stores no value, so `isSkipped`
 * has to count - otherwise a review full of "I don't know" could never finish.
 */
export const isAnswered = ({ currentAnswer, isSkipped, }) => Boolean(currentAnswer) || isSkipped;
//# sourceMappingURL=types.js.map